// CHH 2025-01: Wenn die Seite mit ?payback=true aufgerufen wird, werden alle CMP-Consents gesetzt, damit
//              cmp einmal laden kann. Dabei wird der emid local storage gesetzt. Beim nächsten
//              Seitenwechsel wird die emd in uppr-generic in die cart attributes geschrieben
//              und serverseitig an uppr nach der conversion übertragen.
//              Timeout und zusätzlicher eventlistener sind da, weil cmp nicht immer sofort geladen ist.

let paybackProcessed = false
let cmpPaybackFn = (_eventname, _cmpobject, _subtype) => {
    if (paybackProcessed) {
        return
    }
    // console.debug('Payback CMP: event triggered', _eventname, _cmpobject, _subtype)

    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('payback') === 'true') {
        setTimeout(() => {
            // __cmp("setVendorConsent", ["c66253", 1]); // payback
            __cmp("setVendorConsent", ["459", 1]);
            __cmp("setVendorConsent", ["34", 1]);
            __cmp("setVendorConsent", ["21", 1]);
            __cmp("setVendorConsent", ["755", 1]);
            __cmp("setVendorConsent", ["50", 1]);
            __cmp("setVendorConsent", ["40", 1]);
            __cmp("setVendorConsent", ["39", 1]);
            console.debug('Payback CMP: set vendor consent');
        }, 500);
    }
    __cmp("removeEventListener",["consent",cmpPaybackFn,false],null)
    paybackProcessed = true
}

cmpPaybackFn()
paybackProcessed = false
__cmp("addEventListener", ["consent", cmpPaybackFn, false], null)
// console.debug('Payback CMP event set')
